import type {z} from 'zod';

export const error: z.core.$ZodErrorMap = issue => {
    if (issue.code === 'too_small' && issue.minimum === 1 && issue.origin === 'string') {
        return 'Required';
    }

    if (issue.code === 'invalid_type' && issue.expected === 'string' && issue.input === null) {
        return 'Required';
    }

    // Returning undefined falls through to Zod's default message.
    return undefined;
};
